import React from "react";

import PageHeading from "2g-page-heading";

import ProvozniInformaceEditaceWidget from "b2b/components/provozni-informace-editace-widget";

export function ProvozniInformaceEditaceWidgetExample() {
  return (
    <>
      <PageHeading>ProvozniInformaceEditaceWidget</PageHeading>
      <div data-testid="ProvozniInformaceEditaceWidgetExample">
        <ProvozniInformaceEditaceWidget />
      </div>
    </>
  );
}

ProvozniInformaceEditaceWidgetExample.propTypes = {};

export default React.memo(ProvozniInformaceEditaceWidgetExample);
